import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "RichText" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, " Forestående projekt er omfattet af affaldsbekendtgørelses krav om screening, kortlægning og anmeldelse af byggeaffald (1), da projektet frembringer mere end 1 ton affald. ", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, " Der er påbegyndt en screening af miljøproblematiske stoffer i bygningsmassen og derfor er der foretaget en indledende miljøundersøgelse. Eksempelvis: ", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, "PCB"),
  /*#__PURE__*/_createElementVNode("li", null, "Klorparaffiner"),
  /*#__PURE__*/_createElementVNode("li", null, "Tungmetaller (bly, cadmium, krom, nikkel, kobber, zink og kviksølv)"),
  /*#__PURE__*/_createElementVNode("li", null, "Asbest"),
  /*#__PURE__*/_createElementVNode("li", null, "PAH"),
  /*#__PURE__*/_createElementVNode("li", null, "Kulbrinter")
], -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode("prøver og vurderinger")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(". ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Prøveudtagningssteder fremgår under ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("bygninger og grundplaner")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(", hvor det er angivet på en vejledende plantegning samt med fotodokumentation under den enkelte registrering. ")
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Analyserapporten er vedlagt som bilag til nærværende screeningsrapport. Under ")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("prøver og vurderinger")
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" og under den enkelte registrering fremgår det ved farvemarkering, hvilken affaldskategori den pågældende prøve og dermed det pågældende bygningsmateriale hører ind under. ")
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", null, " I forbindelse med nærværende rapport er ejendommen ikke undersøgt for eventuel jordforurening. ", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "ReferenceList" }, [
  /*#__PURE__*/_createElementVNode("h2", { id: "aria-reference-header" }, "Referencer"),
  /*#__PURE__*/_createElementVNode("ol", { "aria-labelledby": "aria-reference-header" }, [
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createTextVNode(" (1) "),
      /*#__PURE__*/_createElementVNode("a", {
        href: "https://www.retsinformation.dk/eli/lta/2021/2512",
        target: "_blank"
      }, "Bekendtgørelse om affald")
    ])
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PaneTitle = _resolveComponent("PaneTitle")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_PaneTitle, { paneID: 'child' }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.index) + ". Besigtigelse og prøveudtagning", 1)
        ]),
        _: 1
      }),
      _hoisted_2,
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("p", null, [
        _createTextVNode(" Der er i forbindelse med nærværende undersøgelse i alt udtaget " + _toDisplayString(_ctx.samplesCount) + " materialeprøver til analyse. Materialeprøver og analyseresultater fremgår under ", 1),
        _createVNode(_component_router_link, { to: { name: 'SamplesAndAssesments' } }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }),
        _hoisted_6
      ]),
      _createElementVNode("p", null, [
        _hoisted_7,
        _createVNode(_component_router_link, { to: { name: 'BuildingsAndFloorPlans' } }, {
          default: _withCtx(() => [
            _hoisted_8
          ]),
          _: 1
        }),
        _hoisted_9
      ]),
      _createElementVNode("p", null, [
        _hoisted_10,
        _createVNode(_component_router_link, { to: { name: 'SamplesAndAssesments' } }, {
          default: _withCtx(() => [
            _hoisted_11
          ]),
          _: 1
        }),
        _hoisted_12
      ]),
      _hoisted_13
    ]),
    _hoisted_14
  ], 64))
}